

import {typesBook} from './svtypes/bookTypes'

import {SV_SOJ_ORCMOCK_ADDRESS} from '../constants'
const _ = require('lodash')

let initStore = {
    loading: false,
    error: false,
    /*sva*/
    errob :{
        "timestamp": "2015-08-23T02:27:18.038+0000",
        "status": 500,
        "error": "Default Error",
        "message": "500 null",
        "path": "/kk/svaddressDetailPost"
    },
    crudsuccessob :{
        "timestamp": "2015-08-23T02:27:18.038+0000",
        "status": 200,
        "error": "Default Error",
        "message": "500 null",
        "path": "/kk/svaddressDetailPost"
    },
    /*svae */
    my_data: [],
    loadingRESERVATION:false,
    errorRESERVATION:false,
    my_data_traveller:{
        "id": "addLeft_step",
        "gene": "addLeft_step",
        "dcountry": "China",
        "privateparking":false,
        "rentcar":false,
        "bookTaxi":false,
        "needFlight":false,
        "arrivalTimeZone":"tz_pst",
        "fname": "John",
        "lname": "Glen",
        "email": "john123@yahoo.com",
        "address": "Glen",
        "city": "Glen",
        "state": "Glen",
        "zip": "12110",
        "country": "Glen",
        "isdcode": "+1",
        "phone": "Glen",
        "bookingAgentType": "self",
        "traveType": "Personal",
        "specialRequests": "Wheel chair and Senior Citizen",
        "gname": "Glen",
        "gemail": "Glen@yahoo.com",
        "card": "1234-1234--1234--1234",
        "cvv": "Glen",
        "mmexp": "04",
        "yyyyexp": "2028"
    },
    custProfile: {
        "customerId": 6,
        "addressId":-1
    },
    my_data_card:{
        "id": "-4",
        "cardId": "-4",
    
       
        "card": "7777-1234--1234--1234",
        "cvv": "777",
        "mmexp": "07",
        "yyyyexp": "77",
        "otherDetails" :"Default facility",
        "specialRequests": "Default chair and Senior Citizen",
        "privateparking":false,
            "rentcar":false,
            "bookTaxi":false,
            "needFlight":false,
            "arrivalTimeZone":"tz_pst"
      
        
    
      },

    my_data_address: {
        "id": 6,
        "addressId": 6,
        "customerId": 6,
        "name": "alen beta",
        "fname": "alen",
        "lname": "beta",
        "phone": "5121231234",
        "email": "alen11@br.com",
        "login": "alenb",
        "password": null,
        "otherDetails": "need pickup",
        "city": "san jose",
        "state": "ca",
        "country": "usa",
        "address": null,
        "zip": "95123",
        "zipcode": "95123",
        "isdcode": "1",
        "addressType": "B",
        "createdDate": null,
        "modifiedDate": null,
        "createdBy": null,
        "modifiedBy": null
    },
    my_data_review:{
        "Request": {
            "checkin": "OK",
            "stay": "6",
            "stayInit": "nights",
            "checkout": "UU12345",
            "checkinTime": "Sat, Sept 9, 3027",
            "checkinTimePrefix": "From 3:00 PM",
            "checkoutTimePrefix": "Until 11:00 AM",
            "checkoutTime": "Sat, Sept 16, 3027"
        },
        "spaceDet": {
        
            "space_details": "Queen Room with Two Queen Beds",
            "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
            "cancellation": "Free cancellation before December 9, 2024 ",
            "guests": "2 adults ",
            "cleaniness_score" : "7.7",
            "non_smoking":true,
    
            "space_amenity_name": [
                "300 feet elevator",
                "air conditioning",
                "private bathroom"
            ]
           
           
        },
        "booking": {
            "resort_name": "Cambria Hotel Orlando Airport",
            "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
            "stayDet": "6 nights",
            "num_reviews": 101,
            "amenity_name": [
                "HotTub",
                "Spa",
                "Swimming pool",
                "Laundry"
            ],
            "num_reviews_label": "Good, ",
            "rating_detail":" Excellebt, 9.1",
            "num_reviews_detail": "Good, 101 reviews"
           
        },
        "price": {
            "total": "$923",
            "depositValue":"$200.26",
            "depositName":"Damage Deposit (Fully refundable)",
            "currency": "usd",
            "tax": {
               
                "taxTotal": "$102.34",
                "maintax": "$49.08",
                "citytax": "$53.26",
    
                "taxPercent": "6",
                "citytaxPercent": "6.5"
            }
        },
        "id": "addLeft_step",
        "gene": "addLeft_step",
        "dcountry": "China",
        "privateparking":false,
        "rentcar":false,
        "bookTaxi":false,
        "needFlight":false,
        "arrivalTimeZone":"tz_pst",
        "fname": "John",
        "lname": "Glen",
        "email": "john123@yahoo.com",
        "address": "Glen",
        "city": "Glen",
        "state": "Glen",
        "zip": "12110",
        "country": "Glen",
        "isdcode": "+1",
        "phone": "Glen",
        "bookingAgentType": "self",
        "traveType": "Personal",
        "specialRequests": "Wheel chair and Senior Citizen",
        "gname": "Glen",
        "gemail": "Glen@yahoo.com",
        "card": "1234-1234--1234--1234",
        "cvv": "Glen",
        "mmexp": "04",
        "yyyyexp": "2028"
    },
    my_data_price_confirmation:{

        "status":"OK",
        "confirmationNumber":"UU12345",
        "chekinDate":"Jan 3027"
    },
    svr_soj_detail_images_ob:{
        "images":[`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj2.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj3.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj4.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj5.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj6.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj7.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj8.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj9.jpg`],
        "gallery":[`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj2.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj3.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj4.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj5.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj6.jpg` ],
        "arcade":[`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj2.jpg`],
        "face":[`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`]
    
    },
    
    sojourns:[]
    
}

export default (state = initStore, action) => {
    console.log(action);
    let januState, svns;
    switch (action.type) {
        case "book/LIST_SOJOURNS":

     console.log('tasks LIST_SOJOURNS reducer')
     
    
      console.log(svns)
      if(Array.isArray(action.sojourns) && (action.sojourns.length >0)){
       
        state.sojourns =_.clone(action.sojourns)
      }
     svns = Object.assign({}, state, {sojourns:action.sojourns})
      console.log('sv reduce --for LIST_TASKS')
      console.log(svns)

      return svns
        case 'GET_PRICEANDTAX_SUCCESS':
            console.log("reduce %%%%%%%%GET_PRICEANDTAX_SUCCESS  success*****************");
            console.log(action.payload.my_data_price_confirmation);
            // let januState = {...state, loading: false, my_data: action.payload.my_data}
            /*sva
            
            januState = {...state, loadingRESERVATION: false, my_data_price_confirmation: action.payload.my_data_price_confirmation}
            */
            januState = {...state, loadingRESERVATION: false,errorRESERVATION: true, errob:null,crudsuccessob: action.payload.crudsuccessob, my_data_price_confirmation: action.payload.my_data_price_confirmation}
            
            return januState

        case 'GET_PRICEANDTAX_BEGIN':
            console.log("loading")
            return {...state, loadingRESERVATION: true}
        case 'GET_PRICEANDTAX_ERROR':
            console.log("error")
            return {...state, errorRESERVATION: true, errob:action.payload.errob,crudsuccessob:null}

        /*sva */
        case "RESET_PRICEANDTAX_INIT":
            let  my_data_price_confirmation_init = {
                "id":-11,
                "status":"FAILED",
                "confirmationNumber":"",
                "chekinDate":""
            }
             console.log("reduce %%%%%%%%RESET_SAVESTOREDCARD_INIT  success*****************");
                januState = {...state, errorRESERVATION:false, loadingRESERVATION:false, crudsuccessob:null, my_data_price_confirmation:my_data_price_confirmation_init}
 
        /*svae */
        
        case 'GET_REVIEW_SUCCESS':
            console.log("reduce %%%%%%%%GET_REVIEW_SUCCESS  success*****************");
            console.log(action.payload.my_data_review);
            // let januState = {...state, loading: false, my_data: action.payload.my_data}
            januState = {...state, loadingRESERVATION: false, my_data_review: action.payload.my_data_review}
            return januState
        case 'MYRESERVATIONS_PRIMARY_ADDRESS':
                console.log("reduce %%%%%%%%GET_REVIEW_SUCCESS  success*****************");
                console.log(action.payload.my_data_address);
                // let januState = {...state, loading: false, my_data: action.payload.my_data}
                januState = {...state,  my_data_address: action.payload.my_data_address}
                return januState

        case 'GET_REVIEW_MYRESERVATION_SV_SUCCESS':
                console.log("reduce %%%%%%%%GET_REVIEW_MYRESERVATION_SV_SUCCESS  success*****************");
                console.log(action.payload);

                // let januState = {...state, loading: false, my_data: action.payload.my_data}
                januState = {...state, errob:null,crudsuccessob:null,loadingRESERVATION: false,my_data_card:action.payload.my_data_card, my_data_address: action.payload.my_data_address,custProfile:action.payload.custProfile, my_data_review: action.payload.my_data_review}
                return januState
        case 'GET_REVIEW_BEGIN':
                console.log("loading")
                return {...state, loadingRESERVATION: true}
        case 'GET_REVIEW_ERROR':
                console.log("error")
                return {...state, errorRESERVATION: true}
        case 'SAVETRAVELLER_REVIEW_SUCCESS':
                    console.log("reduce %%%%%%%%SAVETRAVELLER_REVIEW_SUCCESS   success*****************");
                    console.log(action.payload.my_data_traveller);
                    // let januState = {...state, loading: false, my_data: action.payload.my_data}
                    januState = {...state,  my_data_traveller: action.payload.my_data_traveller}
                    return januState
        
        default:
            return state
    }
}